import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import './init'
import router from './router'
// import store from './store'
import axiosInstance from '@/common/axios'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/common/installVant'
import VueClipboard from 'vue-clipboard2'
import '@/assets/styles/common/index.scss' // 覆盖antd.css的样式影响

// 后续优先使用KDesign，Antd和Vant将逐步改为按需加载
import '@kdocs/kdesign-theme/default.css' // KDesign 需要和主题搭配使用
import '@kdocs/kdesign-vue/lib/theme-chalk/index.css'
import KDesignVue from '@kdocs/kdesign-vue'

Vue.config.productionTip = false
Vue.prototype.$http = axiosInstance
Vue.use(Antd)
Vue.use(KDesignVue)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
